import { render, staticRenderFns } from "./PdpEntry.vue?vue&type=template&id=241699c8&scoped=true&lang=pug&"
import script from "./PdpEntry.vue?vue&type=script&lang=js&"
export * from "./PdpEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241699c8",
  null
  
)

export default component.exports